// Product data for the webstore
export const Products = [
  {
    id: 1,
    name: "Tiptoe& Cap",
    color: "White",
    size: "XS",
    price: 15.0,
    photo: "/img/product_image_temp.jpg",
  },
  {
    id: 2,
    name: "Tiptoe& Cap",
    color: "White",
    size: "S",
    price: 15.0,
    photo: "/img/product_image_temp.jpg",
  },
  {
    id: 3,
    name: "Tiptoe& Cap",
    color: "White",
    size: "M",
    price: 15.0,
    photo: "/img/product_image_temp.jpg",
  },
  {
    id: 4,
    name: "Product Example 1",
    color: "White",
    size: "L",
    price: 16.0,
    photo: "/img/product_image_temp.jpg",
  },
];
